// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import Styles from "../../styles/preview/video.module.scss";
// import { adminRoutes } from "../../routers/AdminRouters";
// import { io } from "socket.io-client";
// import { ApiEndpoints, LocalStorageKeys } from "../../core";
// import { getScheduleGym } from "../../services";
// import { useDispatch, useSelector } from "react-redux";
// import pauseIcon from "../../assets/dashboard/Menu/pause.png";
// import playIcon from "../../assets/dashboard/Menu/play.png";
// import { updateIsPlayingState, updateProgressState } from "../../redux";

// function secondsToHhmmss(totalSeconds) {
//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);
//   const seconds = totalSeconds % 60;
//   return [hours, minutes, seconds]
//     .map((unit) => String(unit).padStart(2, "0"))
//     .join(":");
// }

// const Video = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { gymSchedule } = useSelector((state) => state.schedule);
//   const dispatch = useDispatch();
//   const [socket, setSocket] = useState(null);
//   const [manualOverride, setManualOverride] = useState(false);
//   const manualOverrideRef = useRef(manualOverride);
//   useEffect(() => {
//     manualOverrideRef.current = manualOverride;
//   }, [manualOverride]);

//   // Get today's schedule and the current format
//   const [currentDate] = useState(new Date());
//   const todaySchedule = gymSchedule?.find((schedule) => {
//     const scheduleDate = new Date(schedule.date);
//     return scheduleDate.toDateString() === currentDate.toDateString();
//   });
//   const currentFormatIndex = location.state?.formatIndex ?? 0;
//   const currentFormat = todaySchedule?.session?.formats?.[currentFormatIndex];
//   const duration = currentFormat?.duration - currentFormat?.restTime || 0;
//   const subFormat = currentFormat?.subFormat || 0;
//   const totalDuration = todaySchedule?.session?.duration || 0;

//   const [remainingDuration, setRemainingDuration] = useState(duration);
// const previousFormatsDuration = todaySchedule?.session?.formats
//   ?.slice(0, currentFormatIndex) // Sum all previous formats
//   .reduce((sum, format) => sum + (format.duration ), 0) || 0;

// const dynamicCumulativeDuration =
//   previousFormatsDuration + (currentFormat?.duration - remainingDuration);

//   const countdownTimer = useRef(null);
//   const hasNavigated = useRef(false);

//   const progressData = useSelector((state) => state.schedule.progress);
//   const isPlayingData = useSelector((state) => state.schedule.isPlaying);

//   // For videos
//   const videoRefs = useRef([]);
//   const videosFromFormat =
//     currentFormat && Array.isArray(currentFormat.exercises)
//       ? currentFormat.exercises.reduce((acc, item) => {
//           const primaryVideo = item?.exercise?.videos?.primary;
//           const secondaryVideo = item?.exercise?.videos?.primary;
//           if (primaryVideo) {
//             acc.push(`${ApiEndpoints.baseAssetUrl}/${primaryVideo}`);
//           }
//           // if (secondaryVideo) {
//           //   acc.push(`${ApiEndpoints.baseAssetUrl}/${secondaryVideo}`);
//           // }
//           return acc;
//         }, [])
//       : [];

//   const videos =
//     videosFromFormat.length > 0
//       ? videosFromFormat
//       : [
//           "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4",
//           "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4",
//           "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4",
//           "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4",
//           "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4",
//         ];
//   useEffect(() => {
//     getScheduleGym();
//   }, []);

//   useEffect(() => {
//     if (remainingDuration > 0 && isPlayingData[todaySchedule?._id]) {
//       countdownTimer.current = setInterval(() => {
//         setRemainingDuration((prev) => prev - 1);
//       }, 1000);
//     } else {
//       clearInterval(countdownTimer.current);
//     }
//     if (remainingDuration === 0 && !hasNavigated.current) {
//       hasNavigated.current = true;
//       setTimeout(() => {
//         const totalFormats = todaySchedule?.session?.formats?.length || 0;
//         if (currentFormatIndex === totalFormats - 1) {
//           navigate(adminRoutes.thankYou);
//         } else {
//           navigate(adminRoutes.rest, {
//             state: { formatIndex: currentFormatIndex },
//           });
//         }
//       }, 1000);
//     }
//     return () => clearInterval(countdownTimer.current);
//   }, [
//     remainingDuration,
//     isPlayingData,
//     navigate,
//     currentFormatIndex,
//     todaySchedule,
//   ]);
// // Updated socket event handling in Video.jsx
// useEffect(() => {
//   if (!todaySchedule) return;
//   const sessionId = todaySchedule._id;
//   const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);
//   if (!gymToken) {
//     console.error("Token not found in local storage");
//     return;
//   }
//   const socketInstance = io(ApiEndpoints.serverURL, {
//     reconnectionDelayMax: 10000,
//     auth: {
//       token: `Bearer ${gymToken}`,
//     },
//   });
//   setSocket(socketInstance);

//   // Listen for both play and pause on preview_control_status
//   socketInstance.on("preview_control_status", (data) => {
//     if (data.status === "play") {
//       dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
//     } else if (data.status === "pause") {
//       dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
//     }
//   });

//   // Keep this listener as well for backward compatibility
//   socketInstance.on("preview_progress_status", (data) => {
//     if (data.status === "play") {
//       dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
//     }
//   });

//   console.log("Socket event listeners set up");

//   return () => {
//     socketInstance.off("preview_progress_status");
//     socketInstance.off("preview_control_status");
//   };
// }, [todaySchedule, dispatch]);

//   const handlePlay = (sessionId) => {
//     dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
//     if (socket) {
//       socket.emit("preview_control_status", {
//         sessionId,
//         status: "play",
//       });
//     }
//   };

//   const handlePause = (sessionId) => {
//     dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
//     if (socket) {
//       socket.emit("preview_control_status", {
//         sessionId,
//         status: "pause",
//       });
//     }
//   };

//   const sessionId = todaySchedule?._id;

//   return (
//     <div className={Styles.video_container}>

//       <div className={Styles.main_container}>
//       <div className={Styles.header}>
//         <h2 className={Styles.sub_title}>Quality Reps</h2>
//         <div className={Styles.timer_section}>
//           <h1 className={Styles.title}>
//             {todaySchedule ? todaySchedule.session.name : "No Session Today"}
//           </h1>
//           <div className={Styles.timer_child}>
//             <span className={Styles.timer_label}>Continuous Work</span>
//             <span className={Styles.timer_button}>3 Min</span>
//           </div>
//         </div>
//         <div className={Styles.amrap_section}>
//           <div className={Styles.amrap_label}>{subFormat}</div>
//           <div className={Styles.timer_display}>
//             {isPlayingData[sessionId]
//               ? secondsToHhmmss(remainingDuration)
//               : secondsToHhmmss(remainingDuration)}
//           </div>
//         </div>
//       </div>

//       <div
//         className={`${Styles.video_grid} ${
//           Styles[`videos_${Math.min(videos.length, 5)}`]
//         }`}
//       >
//         {currentFormat?.exercises?.map((exerciseItem, index) => {
//           const exerciseName =
//             exerciseItem?.exercise?.name || "Unknown Exercise";
//           const sets = exerciseItem?.variables?.sets || 0;
//           const reps = exerciseItem?.variables?.reps || 0;
//           const videoSrc = exerciseItem?.exercise?.videos?.primary
//             ? `${ApiEndpoints.baseAssetUrl}/${exerciseItem.exercise.videos.primary}`
//             : "";
//           return (
//             <div key={index} className={Styles.video_card}>
//               {videoSrc && (
//                 <video
//                   ref={(el) => (videoRefs.current[index] = el)}
//                   controls={false}
//                   playsInline={true}
//                   loop={true}
//                   autoPlay={true}
//                   muted={true}
//                    preload="auto"
//                   src={videoSrc}
//                   className={Styles.video}
//                 ></video>
//               )}
//               <div className={Styles.video_info}>
//                 <p className={Styles.video_title}>
//                   {exerciseName.toUpperCase()}
//                 </p>
//                 <div className={Styles.video_details}>
//                   <span className={Styles.video_sets}>
//                     SETS <span className={Styles.highlight}>{sets}</span>
//                   </span>{" "}
//                   <span className={Styles.separator}>|</span>
//                   <span className={Styles.video_reps}>
//                     REPS <span className={Styles.highlight}>{reps}</span>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       </div>

//      {/* progressbar  */}

//      <div className={Styles.progress_section}>
//         <div className={Styles.progress_bar_child}>
//           <p>Session Time Progress</p>
//           <div className={Styles.progress_bar}>
//             <div
//               className={Styles.progress_fill}
//               style={{
//                 width: `${(dynamicCumulativeDuration / totalDuration) * 100}%`,
//               }}
//             ></div>
//           </div>
//         </div>
//         <div className={Styles.control_buttons}>
//           {!isPlayingData[sessionId] ? (
//             <button
//               className={Styles.play_button}
//               onClick={() => handlePlay(sessionId)}
//             >
//               <img src={playIcon} alt="Play Icon" className={Styles.icon} />
//               Play
//             </button>
//           ) : (
//             <button
//               className={Styles.pause_button}
//               onClick={() => handlePause(sessionId)}
//             >
//               <img src={pauseIcon} alt="Pause Icon" className={Styles.icon} />
//               &nbsp; Pause
//             </button>
//           )}
//         </div>
//       </div>

//     </div>
//   );
// };

// export default Video;

import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "../../styles/preview/video.module.scss";
import { adminRoutes } from "../../routers/AdminRouters";
import { io } from "socket.io-client";
import { ApiEndpoints, LocalStorageKeys } from "../../core";
import { getScheduleGym } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import pauseIcon from "../../assets/dashboard/Menu/pause.png";
import playIcon from "../../assets/dashboard/Menu/play.png";
import { updateIsPlayingState, updateProgressState } from "../../redux";
import imgSrc from "../../assets/preview/ttrpreviewbg.webp";

function secondsToHhmmss(totalSeconds) {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, "0"))
    .join(":");
}

const Video = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { gymSchedule } = useSelector((state) => state.schedule);
  const dispatch = useDispatch();
  const [socket, setSocket] = useState(null);
  const [manualOverride, setManualOverride] = useState(false);
  const manualOverrideRef = useRef(manualOverride);

  // Track video loading states
  const [videoLoadingStatus, setVideoLoadingStatus] = useState({});

  useEffect(() => {
    manualOverrideRef.current = manualOverride;
  }, [manualOverride]);

  // Get today's schedule and the current format
  const [currentDate] = useState(new Date());
  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });
  const currentFormatIndex = location.state?.formatIndex ?? 0;
  const currentFormat = todaySchedule?.session?.formats?.[currentFormatIndex];
  const duration = currentFormat?.duration - currentFormat?.restTime || 0;
  const subFormat = currentFormat?.subFormat || 0;
  const totalDuration = todaySchedule?.session?.duration || 0;

  const [remainingDuration, setRemainingDuration] = useState(duration);
  const previousFormatsDuration =
    todaySchedule?.session?.formats
      ?.slice(0, currentFormatIndex) // Sum all previous formats
      .reduce((sum, format) => sum + format.duration, 0) || 0;

  const dynamicCumulativeDuration =
    previousFormatsDuration + (currentFormat?.duration - remainingDuration);

  const countdownTimer = useRef(null);
  const hasNavigated = useRef(false);

  const progressData = useSelector((state) => state.schedule.progress);
  const isPlayingData = useSelector((state) => state.schedule.isPlaying);

  // For videos
  const videoRefs = useRef([]);
  const videosFromFormat =
    currentFormat && Array.isArray(currentFormat.exercises)
      ? currentFormat.exercises.reduce((acc, item) => {
          const primaryVideo = item?.exercise?.videos?.primary;
          if (primaryVideo) {
            acc.push(`${ApiEndpoints.baseAssetUrl}/${primaryVideo}`);
          }
          return acc;
        }, [])
      : [];

  const fallbackVideoUrl =
    "https://assets.ttrprogramming.com/bddde57a-245b-4ac2-9eff-7a6ac3dbfad8.mp4";

  // Default videos array if no videos from format
  const videos =
    videosFromFormat.length > 0
      ? videosFromFormat
      : Array(5).fill(fallbackVideoUrl);

  useEffect(() => {
    getScheduleGym();
  }, []);

  // Handle video playback based on isPlaying state
  useEffect(() => {
    if (!todaySchedule) return;

    const sessionId = todaySchedule._id;
    const isPlaying = isPlayingData[sessionId];

    // Control all videos based on isPlaying state
    videoRefs.current.forEach((videoEl) => {
      if (!videoEl) return;

      if (isPlaying) {
        // Ensure play happens
        const playPromise = videoEl.play();

        // Handle potential play() promise rejection
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            console.error("Video play failed:", error);
            // Try to play again with user interaction trigger
            videoEl.muted = true; // Ensure muted for autoplay
          });
        }
      } else {
        videoEl.pause();
      }
    });
  }, [isPlayingData, todaySchedule]);

  useEffect(() => {
    if (remainingDuration > 0 && isPlayingData[todaySchedule?._id]) {
      countdownTimer.current = setInterval(() => {
        setRemainingDuration((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(countdownTimer.current);
    }
    if (remainingDuration === 0 && !hasNavigated.current) {
      hasNavigated.current = true;
      setTimeout(() => {
        const totalFormats = todaySchedule?.session?.formats?.length || 0;
        if (currentFormatIndex === totalFormats - 1) {
          navigate(adminRoutes.thankYou);
        } else {
          navigate(adminRoutes.rest, {
            state: { formatIndex: currentFormatIndex },
          });
        }
      }, 1000);
    }
    return () => clearInterval(countdownTimer.current);
  }, [
    remainingDuration,
    isPlayingData,
    navigate,
    currentFormatIndex,
    todaySchedule,
  ]);

  // Preload videos
  useEffect(() => {
    if (!currentFormat?.exercises) return;

    // Create an array to track loading status
    const loadingStatus = {};
    currentFormat.exercises.forEach((exerciseItem, index) => {
      loadingStatus[index] = "loading";
    });
    setVideoLoadingStatus(loadingStatus);

    // Function to preload video
    const preloadVideo = (url, index) => {
      if (!url) {
        setVideoLoadingStatus((prev) => ({ ...prev, [index]: "failed" }));
        return;
      }

      const video = document.createElement("video");

      video.onloadeddata = () => {
        setVideoLoadingStatus((prev) => ({ ...prev, [index]: "loaded" }));
      };

      video.onerror = () => {
        console.error(`Failed to load video at index ${index}`);
        setVideoLoadingStatus((prev) => ({ ...prev, [index]: "failed" }));
      };

      // Set attributes for faster loading
      video.preload = "auto";
      video.muted = true;
      video.src = url;
    };

    // Preload each video
    currentFormat.exercises.forEach((exerciseItem, index) => {
      const videoSrc = exerciseItem?.exercise?.videos?.primary
        ? `${ApiEndpoints.baseAssetUrl}/${exerciseItem.exercise.videos.primary}`
        : ``;

      preloadVideo(videoSrc, index);
    });
  }, [currentFormat]);

  useEffect(() => {
    if (!todaySchedule) return;
    const sessionId = todaySchedule._id;
    const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);
    if (!gymToken) {
      console.error("Token not found in local storage");
      return;
    }
    const socketInstance = io(ApiEndpoints.serverURL, {
      reconnectionDelayMax: 10000,
      auth: {
        token: `Bearer ${gymToken}`,
      },
    });

    setSocket(socketInstance);

    socketInstance.on("preview_control_status", (data) => {
      console.log("Preview Control Status:", data);

      if (data.status === "play") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
      } else if (data.status === "pause") {
        dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
      }
    });

    return () => {
      socketInstance.off("preview_control_status");
      socketInstance.disconnect();
    };
  }, [todaySchedule, dispatch]);

  const handlePlay = (sessionId) => {
    dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
    if (socket) {
      socket.emit("preview_control_status", {
        sessionId,
        status: "play",
      });
    }
  };

  const handlePause = (sessionId) => {
    dispatch(updateIsPlayingState({ sessionId, isPlaying: false }));
    if (socket) {
      socket.emit("preview_control_status", {
        sessionId,
        status: "pause",
      });
    }
  };

  // Handle video load events
  const handleVideoLoad = (index) => {
    setVideoLoadingStatus((prev) => ({ ...prev, [index]: "loaded" }));
  };

  // Handle video error events
  const handleVideoError = (index) => {
    console.error(`Error loading video at index ${index}`);
    setVideoLoadingStatus((prev) => ({ ...prev, [index]: "failed" }));
  };

  const sessionId = todaySchedule?._id;

  return (
    <div className={Styles.video_container}>
      <div className={Styles.main_container}>
        <div className={Styles.header}>
          <h1 className={Styles.sub_title}>
                          {todaySchedule ? todaySchedule.session.name : "No Session Today"}

          </h1>
          {/* <div className={Styles.timer_section}>
            <h1 className={Styles.title}>
              {todaySchedule ? todaySchedule.session.name : "No Session Today"}
            </h1>
            <div className={Styles.timer_child}>
              <span className={Styles.timer_label}>Continuous Work</span>
              <span className={Styles.timer_button}>3 Min</span>
            </div>
          </div> */}
          <div className={Styles.amrap_section}>
            <div className={Styles.amrap_label}>{subFormat}</div>
            <div className={Styles.timer_display}>
              {secondsToHhmmss(remainingDuration)}
            </div>
          </div>
        </div>

        <div
          className={`${Styles.video_grid} ${
            Styles[
              `videos_${Math.min(currentFormat?.exercises?.length || 5, 5)}`
            ]
          }`}
        >
          {currentFormat?.exercises?.map((exerciseItem, index) => {
            const exerciseName =
              exerciseItem?.exercise?.name || "Unknown Exercise";
            console.log(exerciseItem, "exerciseItem");

            const sets = exerciseItem?.variables?.sets || 0;
            const reps = exerciseItem?.variables?.reps || 0;
            const tempo = exerciseItem?.variables?.tempos || 0;
            const calories = exerciseItem?.variables?.cals || 0;
            const meters = exerciseItem?.variables?.meters || 0;
            const time = exerciseItem?.variables?.time || 0;

            const videoSrc = exerciseItem?.exercise?.videos?.primary
              ? `${ApiEndpoints.baseAssetUrl}/${exerciseItem.exercise.videos.primary}`
              : `${ApiEndpoints.baseAssetUrl}/${exerciseItem.exercise.videos.secondary}`;

            return (
              <div key={index} className={Styles.video_card}>
                <video
                  ref={(el) => (videoRefs.current[index] = el)}
                  controls={false}
                  playsInline={true}
                  loop={true}
                  autoPlay={isPlayingData[sessionId]}
                  muted={true}
                  preload="auto"
                  src={videoSrc}
                  poster={imgSrc}
                  className={Styles.video}
                  onLoadedData={() => handleVideoLoad(index)}
                  onError={() => handleVideoError(index)}
                />

                {/* Loading indicator */}
                {/* {videoLoadingStatus[index] === "loading" && (
                  <div className={Styles.loading_indicator}>
                    <video
                      controls={false}
                      playsInline={true}
                      loop={true}
                      muted={true}
                      preload="auto"
                      src={imgSrc}
                      className={Styles.video}
                      poster={imgSrc}
                    />
                  </div>
                )} */}

                {/* Error indicator */}
                {videoLoadingStatus[index] === "failed" && (
                  <div className={Styles.error_indicator}>
                    Video failed to load
                  </div>
                )}

                <div className={Styles.video_info}>
                  <p className={Styles.video_title}>
                    {exerciseName.toUpperCase()}
                  </p>
                  <div className={Styles.video_details}>
                    {sets > 0 && (
                      <span className={Styles.video_sets}>
                        SETS <span className={Styles.highlight}>{sets}</span>
                      </span>
                    )}
                    {sets > 0 && (reps > 0 || meters > 0) && (
                      <span className={Styles.separator}>|</span>
                    )}
                    {reps > 0 && (
                      <span className={Styles.video_reps}>
                        REPS <span className={Styles.highlight}>{reps}</span>
                      </span>
                    )}
                    {reps > 0 && meters > 0 && (
                      <span className={Styles.separator}>|</span>
                    )}
                    {meters > 0 && (
                      <span className={Styles.video_reps}>
                        METERS <span className={Styles.highlight}>{meters}</span>
                      </span>
                    )}
                  </div>
                  {(time > 0 || calories > 0 || tempo > 0) && (
                    <div className={Styles.video_details}>
                      {time > 0 && (
                        <span className={Styles.video_reps}>
                          TIME <span className={Styles.highlight}>{time}</span>
                        </span>
                      )}
                      {time > 0 && (calories > 0 || tempo > 0) && (
                        <span className={Styles.separator}>|</span>
                      )}
                      {calories > 0 && (
                        <span className={Styles.video_reps}>
                          CALS <span className={Styles.highlight}>{calories}</span>
                        </span>
                      )}
                      {calories > 0 && tempo > 0 && (
                        <span className={Styles.separator}>|</span>
                      )}
                      {tempo > 0 && (
                        <span className={Styles.video_reps}>
                          TEMPO <span className={Styles.highlight}>{tempo}</span>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* progressbar  */}
      <div className={Styles.progress_section}>
        <div className={Styles.progress_bar_child}>
          <p>Session Time Progress</p>
          <div className={Styles.progress_bar}>
            <div
              className={Styles.progress_fill}
              style={{
                width: `${(dynamicCumulativeDuration / totalDuration) * 100}%`,
              }}
            ></div>
          </div>
        </div>
        <div className={Styles.control_buttons}>
          {!isPlayingData[sessionId] ? (
            <button
              className={Styles.play_button}
              onClick={() => handlePlay(sessionId)}
            >
              <img src={playIcon} alt="Play Icon" className={Styles.icon} />
              Play
            </button>
          ) : (
            <button
              className={Styles.pause_button}
              onClick={() => handlePause(sessionId)}
            >
              <img src={pauseIcon} alt="Pause Icon" className={Styles.icon} />
              &nbsp; Pause
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Video;
